import {Route, BrowserRouter, Routes,} from "react-router-dom";
import React from "react";

import OdontoLuzzi from "../Pages/OdontoLuzzi";
import Home from "../Pages/Home";
import Login from "../Pages/Login";
import Admin from "../Pages/Admin";
import { AuthProvider } from "../Auth/AuthContext";
import PrivateRoute from "../Auth/PrivateRoute";
import Especialidades from "../Pages/Especialidades";
import ScrollToTop from "../Components/ScrollToTop";
import EspecialidadesInterna from "../Pages/EspecialidadeInterna";
import Educacional from "../Pages/Educacional";
import AdminEspec from "../Pages/AdminEspec";
import AdminEdu from "../Pages/AdminEdu";
import AdminEquipe from "../Pages/AdminEquipe";
import AdminBlog from "../Pages/AdminBlog";
import AdminSmileTrips from "../Pages/AdminSmileTrips";
import AdminVideos from "../Pages/AdminVideos";
import Equipe from "../Pages/Equipe";
import SmileTrips from "../Pages/SmileTrips";
import Blog from "../Pages/Blog";
import BlogInterna from "../Pages/BlogInterna";
// import { useEffect } from "react";
// import CookieBanner from "../Components/CookieBanner";
// import PoliticaPrivacidade from "../Pages/PoliticaPrivacidade";

const Rotas = () => {
    // useEffect(() => {
    //     const elements = document.querySelectorAll(".from-right, .from-left, .from-bottom, .from-top");
    
    //     const observer = new IntersectionObserver((entries) => {
    //       entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //           entry.target.classList.add("show");
    //         }
    //       });
    //     }, { threshold: 0.2 });
    
    //     elements.forEach(el => observer.observe(el));
    
    //     return () => observer.disconnect();
    //   }, []);

    return(
        <React.StrictMode>
            <AuthProvider>
                <BrowserRouter>
                    {/* <CookieBanner/> */}
                    <ScrollToTop/>
                    <Routes>
                        <Route element = {<Home/>} path="/"/>
                        <Route element = {<OdontoLuzzi/>} path="/Odonto-Luzzi"/>
                        <Route element = {<Login/>} path="/Login"/> 
                        <Route element = {<Especialidades/>} path="/Especialidades"/>
                        <Route element = {<Educacional/>} path="/Educacional"/>
                        <Route element = {<Equipe/>} path="/Equipe"/>
                        <Route element = {<SmileTrips/>} path="/Smile-Trips"/>
                        <Route element = {<Blog/>} path="/Blog"/>
                        {/* <Route element = {<PoliticaPrivacidade/>} path="/Politica-Privacidade"/> */}
                        <Route path="/Admin" element={
                            <PrivateRoute>
                                <Admin/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Especialidades" element={
                            <PrivateRoute>
                                <AdminEspec/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Educacional" element={
                            <PrivateRoute>
                                <AdminEdu/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Equipe" element={
                            <PrivateRoute>
                                <AdminEquipe/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Blog" element={
                            <PrivateRoute>
                                <AdminBlog/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Smile-Trips" element={
                            <PrivateRoute>
                                <AdminSmileTrips/>
                            </PrivateRoute>
                        } />
                        <Route path="/Admin/Videos-Educacionais" element={
                            <PrivateRoute>
                                <AdminVideos/>
                            </PrivateRoute>
                        } />
                        <Route element = { <EspecialidadesInterna/> } path="/Especialidades/:interna"/>
                        <Route element = { <BlogInterna/>} path="/Blog/:id"/>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </React.StrictMode>
        
        
    )
}

export default Rotas;